import { useQuery } from "@tanstack/react-query";
import { searchChatMessages } from "controller/api/chat/chatSearch";
import { queryKeys } from "controller/cache/helpers/queryKeyGenerator";
import type { SearchChatMessagesInput } from "shared";

export const chatSearchKeys = queryKeys.chatSearch;

export const useSearchChatMessages = ({
  serviceType,
  serviceId,
  query,
  threadId,
  page = 1,
  limit = 20,
}: SearchChatMessagesInput) => {
  return useQuery({
    queryKey: chatSearchKeys.list(serviceId, query, threadId),
    queryFn: () =>
      searchChatMessages({ serviceType, serviceId, query, threadId, page, limit }),
    enabled: Boolean(serviceId && query && query.length >= 2),
    keepPreviousData: true,
  });
};
